// extracted by mini-css-extract-plugin
module.exports = {"AgreementsModal":"AgreementsModal_AgreementsModal___1zWK"};